module.exports = __webpack_public_path__ + "img/home-fill.88dacb0b.svg";